export const data = [
	{
		page: 'Popular Meals',
		link: '/popular-meals'
	},
	{
		page: 'Menu',
		link: '/menu'
	},
	{
		page: 'About Us',
		link: '/about-us'
	}
];

export const sidebarData = [
	{
		page: 'Home',
		link: '/'
	},
	{
		page: 'Popular Meals',
		link: '/popular-meals'
	},
	{
		page: 'Menu',
		link: '/menu'
	},
	{
		page: 'About Us',
		link: '/about-us'
	}
];
